export type CurrencyCode =
  | '%'
  | 'AED'
  | 'AFN'
  | 'AUD'
  | 'AZN'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BND'
  | 'BRL'
  | 'BTC'
  | 'CAD'
  | 'CHF'
  | 'CNY'
  | 'CRC'
  | 'CUP'
  | 'CYP'
  | 'CZK'
  | 'DKK'
  | 'DZD'
  | 'EEK'
  | 'EGP'
  | 'EUR'
  | 'FJD'
  | 'GBP'
  | 'GEL'
  | 'HKD'
  | 'HRK'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JOD'
  | 'JPY'
  | 'KGS'
  | 'KHR'
  | 'KRW'
  | 'KWD'
  | 'LKR'
  | 'LTL'
  | 'LVL'
  | 'MAD'
  | 'MNT'
  | 'MMK'
  | 'MTL'
  | 'MXN'
  | 'MYR'
  | 'NAD'
  | 'NGN'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PGK'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'QAR'
  | 'ROL'
  | 'RON'
  | 'RUB'
  | 'SAR'
  | 'SDG'
  | 'SEK'
  | 'SGD'
  | 'SIT'
  | 'SKK'
  | 'STD'
  | 'THB'
  | 'TRL'
  | 'TRY'
  | 'TWD'
  | 'UAH'
  | 'USD'
  | 'VND'
  | 'XBT'
  | 'XPF'
  | 'ZAR'

export const currencyLocaleString = (
  value: string | number,
  options: {
    lang: string
    code?: CurrencyCode
  }
): string => {
  const { code = 'EUR' } = options
  const locale = `${options.lang}-${options.lang.toUpperCase()}`
  return Number(value).toLocaleString(locale, {
    style: 'currency',
    currency: code,
    maximumFractionDigits: 2,
  })
}
